import React, { useState, useEffect } from 'react';
import { useFetchBlogById } from '@/services/blogService';

export const useBlogDetails = id => {
  const [isLoading, setIsLoading] = useState(true);
  const [blogsData, setBlogsData] = useState(null);
  const { data, error } = useFetchBlogById(id);

  useEffect(() => {
    if (!id) return;
    if (data) {
      console.log('Datos recibidos del blog:', data);
      const singleBlog = Array.isArray(data) ? data[0] : data;
      setBlogsData(singleBlog);
      setIsLoading(false);
    } else if (error) {
      console.error('Error fetching blog details:', error);
      setIsLoading(false);
    }
  }, [data, error, id]);

  return {
    isLoading,
    blogsData,
  };
};
